import { render, staticRenderFns } from "./uploader-release.vue?vue&type=template&id=3299e03a&"
import script from "./uploader-release.vue?vue&type=script&lang=js&"
export * from "./uploader-release.vue?vue&type=script&lang=js&"
import style0 from "./uploader-release.vue?vue&type=style&index=0&id=3299e03a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports